import { Injectable } from '@angular/core';
import { Validators, AbstractControl, FormControl } from '@angular/forms';
import { AppMessages } from '../constants/messages';
import { AppConstants } from '../constants/constants';
import { Utility } from '../../common/utility';
import * as moment from 'moment';

@Injectable()
export class ValidationService {

  constructor() {
  }

  public static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    const errorMessage = AppMessages.errors;
    const value = validatorName.split('/');
    if (validatorName === 'required' || validatorName === 'invalidSpecialCharacters') {
      return Utility.stringFormat(errorMessage[validatorName], [validatorValue]);
    } else if (validatorName.indexOf('invalidRange') !== -1) {
      return Utility.stringFormat(AppMessages.errors.invalidRange, [value[1], value[2]]);
    } else if (validatorName.indexOf('invalidDecimalRange') !== -1) {
      return Utility.stringFormat(AppMessages.errors.invalidDecimalRange, [value[1], value[2]]);
    } else if (validatorName.indexOf('max') !== -1 || validatorName.indexOf('min') !== -1) {
      return Utility.stringFormat(AppMessages.errors[value[0]], [value[1], value[2]]);
    } else if (validatorName.indexOf('mdDatepickerMin') !== -1) {
      return Utility.stringFormat(AppMessages.errors.mdDatepickerMin, [validatorValue, value[1]]);
    }
    // else if (validatorName.indexOf('maxDateFluVaccine') !== -1) {
    //   return errorMessage[AppMessages.errors.maxDateFluVaccine];
    // }
    return errorMessage[validatorName];
  }

  public static attachRequired(formControl, validators) {
    validators.unshift(Validators.required); // push validator at first place in array*/
    formControl.setValidators(validators);
    if (formControl.value === '') {
      formControl.setErrors({ 'required': true });
    }

  }

  public static removeRequired(formControl, validators) {
    formControl.setValidators(validators);
    if (formControl.errors && formControl.errors.hasOwnProperty('required')) {
      formControl.setErrors(null);
    }
  }

  public static attachValidators(formControl, validators) {
    if (!validators) {
      validators.unshift(Validators.required); // push validator at first place in array*!/
    }
    formControl.setValidators(validators);
    formControl.setErrors(formControl.validator(validators));
  }

  public static removeValidators(formControl) {
    formControl.clearValidators(null);
    formControl.setErrors(null);
  }


  public static isValidEmail(formControl) {
    let pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (formControl.value && !pattern.test(formControl.value)) {
      return { 'invalidEmail': true };
    }
    return null;
  }

  public static isValidSurname(formControl) {
    // let pattern = /^([a-zA-Z0-9\s])*$/;
    let pattern = /^([a-zA-Z0-9\s-\[\]'])*$/;
    if (formControl.value && !pattern.test(formControl.value)) {
      return { 'isValidSurname': true };
    }
    return null;
  }

  public static isValidFirstname(formControl) {
    // let pattern = /^([a-zA-Z0-9\s])*$/;
    let pattern = /^([a-zA-Z0-9\s-\[\]'])*$/;
    if (formControl.value && !pattern.test(formControl.value)) {
      return { 'isValidFirstname': true };
    }
    return null;
  }

  public static isValidMiddleName(formControl) {
    // let pattern = /^([a-zA-Z0-9\s])*$/;
    let pattern = /^([a-zA-Z0-9\s-\[\]'])*$/;
    if (formControl.value && !pattern.test(formControl.value)) {
      return { 'isValidMiddleName': true };
    }
    return null;
  }

  public static isValidDate(formControl) {
    const date = formControl.value;
    if (!date || Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime())) {
      return { 'invalidDate': true };
    }
    /* if (!date || date === '') {
       return  { 'required': true };
     } else if ((date && Object.prototype.toString.call(date) !== '[object Date]' || isNaN( date.getTime() ))) {
       return { 'invalidDate': true };
     }*/
    return null;
  }

  /**
   * Format the input follow date string format and set error for formControl if date is invalid
   * @param FormControl formControl
   * @param Event event : input target
   */
  public static validationDate(formControl: AbstractControl, event) {
    const date = formControl.value;
    if (date) {
      event.targetElement.value = Utility.formatDate(date);
    } else {
      const dateControl = new FormControl({ value: event.targetElement.value });
      if (event.targetElement.value !== '') {
        formControl.setErrors(ValidationService.isValidDate(dateControl));
      }
    }
  }

  /**
   * Remove required error when input date is invalid
   * @param FormControl formControl
   * @param Event event : input target
   */
  public static removeRequiredError(formControl: AbstractControl, event) {
    if (formControl.errors && formControl.errors.hasOwnProperty('required') && event.targetElement.value !== '') {
      delete formControl.errors['required'];
    } else {
      formControl.setValidators([Validators.required]);
    }
  }

  /**
   * Compare two dates
   * @param Date object fromDate
   * @param Date object toDate
   * function returns:
   *  -1 : if fromDate < toDate
   *   0 : if fromDate = toDate
   *   1 : if fromDate > toDate
   *  null : if fromDate or toDate is an illegal date
   */

  public static compareDate(fromDate, toDate) {

    if (ValidationService.isValidDate(fromDate) || ValidationService.isValidDate(toDate)) {
      return null;
    }
    // fromDate.value.setHours(0, 0, 0, 0);
    // toDate.value.setHours(0, 0, 0, 0);
    const from = fromDate.value.getTime();
    const to = toDate.value.getTime();
    if (from > to) {
      return 1;
    } else if (from < to) {
      return -1;
    }
    return 0;
  }

   /**
   * Compare two string dates
   * @param Date string fromDate
   * @param Date string toDate
   * function returns:
   *  -1 : if fromDate < toDate
   *   0 : if fromDate = toDate
   *   1 : if fromDate > toDate
   *  null : if fromDate or toDate is an illegal date
   */
  public static compareDateString(fromDate, toDate) {
    fromDate = (typeof fromDate === 'string' || fromDate instanceof String) ? fromDate.split('T')[0] : fromDate;
    toDate = (typeof toDate === 'string' || toDate instanceof String) ? toDate.split('T')[0] : toDate;
    let fDate = new Date(fromDate);
    let tDate = new Date(toDate);
    if (Object.prototype.toString.call(fDate) !== '[object Date]' || isNaN(fDate.getTime())
        || Object.prototype.toString.call(tDate) !== '[object Date]' || isNaN(tDate.getTime())) {
          return null;
    }
    fDate.setHours(0, 0, 0, 0);
    tDate.setHours(0, 0, 0, 0);
    const from = fDate.getTime();
    const to = tDate.getTime();
    if (from > to) {
      return 1;
    } else if (from < to) {
      return -1;
    }
    return 0;
  }

  /** Validation when user input Date of birth : date of birth must be lower than current date
  * @param: FromCOntrol
  */
  public static isValidDateOfBirth(formControl) {
    const selectedDate = formControl.value;
    const currenDateOfBirth = new Date();

    if (selectedDate > currenDateOfBirth) {
      return { 'invalidDateOfBirth': true };
    }
    return null;
  }

  public static isValidDateOfLastMenstrualPeriod(formControl) {
    const selectedDate = formControl.value;
    const currenDate = new Date();

    if (selectedDate > currenDate) {
      return { 'invalidDateOfLastMenstrualPeriod': true };
    }
    return null;
  }

  public static isValidDateOfAdministeredDate(formControl) {
    const selectedDate = formControl.value;
    const currenDate = new Date();

    if (selectedDate > currenDate) {
      return { 'invalidDateOfAdministeredDate': true };
    }
    return null;
  }

  public static isValidMinLength(formControl) {
    const minLength = AppConstants.formConfig.textBox.minLength;
    if (formControl.value.length > 0 && formControl.value.length < minLength) {
      return { 'invalidMinLength': true };
    }
    return null;
  }

  /**
   * Validation if the form value is from 1 to 999
   * @param control
   */
  public static isValidNumber1To999(control: AbstractControl) {
    const pattern = /^(?:[1-9][0-9]{2}|[1-9][0-9]|[1-9])$/;
    if (!pattern.test(control.value)) {
      return { 'invalidRange/1/999': true };
    }
    return null;
  }

  public static isValidNumberFromTo(minValue: number, maxValue: number) {
    const str = 'invalidRange/' + minValue + '/' + maxValue;
    return (input: FormControl) => {
      let value = input.value;
      if (typeof input.value === 'string') {
        value = Number(input.value);
        if (value === NaN) {
          return { [str]: true };
        }
      }
      if (!Number.isInteger(value)) {
        return { [str]: true };
      } else if (minValue > value || maxValue < value) {
        return { [str]: true };
      }

      return null;
    };
  }

  public static isValidDecimalNumberFromTo(minValue: number, maxValue: number) {
    const str = 'invalidDecimalRange/' + minValue + '/' + maxValue;
    return (input: FormControl) => {
      if (!Number.isNaN(input.value)) {
        return { [str]: true };
      } else if (minValue > input.value || maxValue < input.value) {
        return { [str]: true };
      }

      return null;
    };
  }

  public static validateMinDate(minDate: Date, args = 'the past') {
    const str = 'mdDatepickerMin/' + args;
    if (moment.isDate(minDate)) {
      return (input: FormControl) => {
        if (input.value) {
          if (moment.isDate(input.value)) {
            const dateObj = moment(input.value).toObject();
            if (dateObj.years < minDate.getFullYear()) {
              return { [str]: true };
            } else if (dateObj.years === minDate.getFullYear() && dateObj.months < minDate.getMonth()) {
              return { [str]: true };
            } else if (dateObj.years === minDate.getFullYear() && dateObj.months === minDate.getMonth()
              && dateObj.date < minDate.getDate()) {
              return { [str]: true };
            }
            return null;
          }
        }
      };

    }
    return null;
  }

  public static validateMaxDate(maxDate: Date, args = 'is larger ') {
    const str = 'mdDatepickerMin/' + args;
    if (moment.isDate(maxDate)) {
      return (input: FormControl) => {
        if (input.value) {
          if (moment.isDate(input.value)) {
            const dateObj = moment(input.value).toObject();
            if (dateObj.years > maxDate.getFullYear()) {
              return { [str]: true };
            } else if (dateObj.years === maxDate.getFullYear() && dateObj.months > maxDate.getMonth()) {
              return { [str]: true };
            } else if (dateObj.years === maxDate.getFullYear() && dateObj.months === maxDate.getMonth()
              && dateObj.date > maxDate.getDate()) {
              return { [str]: true };
            }
            return null;
          }
        }
      };
    }
  }

  /**
  * Validation if the form value is from 0 to 999
  * @param control
  */
  public static isValidNumber0To999(control: AbstractControl) {
    const pattern = /^\d{1,3}$/;
    if (!pattern.test(control.value)) {
      return { 'invalidRange/0/999': true };
    }
    return null;
  }

  public static isSpecialCharacters(formControl) {
    const pattern = /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g;
    if (pattern.test(formControl.value)) {
      return { 'invalidSpecialCharacters': true };
    }
    return null;
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/services/validation.service.ts